import {
 onMounted, ref, watch,
} from '@vue/composition-api'
import { pushPopup, pushHint } from '@/utils/pushPopup'
import { arr, ICON } from '@/components/@ui/wrapper-matrix/users'
import {
  arrPopup2,
  arrPopup3,
  arrPopup4,
  arrPopupChooseUserWrong,
  nextLesson,
} from './users'
import matrixCard from '@/components/@ui/matrix-card'
import wrapperMatrix from '@/components/@ui/wrapper-matrix'
import authorCard from '@/components/@ui/wrapper-matrix/components/author'
import iconCard from '@/components/@ui/wrapper-matrix/components/icon'
import numberCard from './components/number'


export default {
  components: {
    matrixCard,
    authorCard,
    iconCard,
    numberCard,
    wrapperMatrix,
  },
  props: {
    arrMatrix: {
      type: Array,
    },
    arrPopup1: {
      type: Array,
    },
    task1: {
      type: Array,
    },
    task2: {
      type: Array,
    },
    result: {
      type: Boolean,
      default: true,
    },
    arrPopupChooseUser: {
      type: Array,
    },
    authorMusic: String,
  },
  setup(props, { emit }) {
    const clickIndex = ref(null)
    const proxyMatrixArr = ref(props.arrMatrix)
    const messages = ref([])
    const similarUser = ref(false)
    const similarUserActive = ref(false)

    const task = ref(props.task1)

    const selectedRow = ref(null)
    const selectedCol = ref(null)
    const stage = ref(0)
    const active = ref(0)
    // const maxIndex = ref(0)

    const handleMouseOver = (i, j) => {
      selectedRow.value = i
      selectedCol.value = j
    }

    const handleMouseOut = () => {
      selectedRow.value = null
      selectedCol.value = null
    }

    const handleMouseOverRow = (i) => {
      selectedRow.value = i
    }

    const handleMouseOutRow = () => {
      selectedRow.value = null
    }
    const isSelectedRow = (row) => {
      if (+row === +proxyMatrixArr.value.length - 1) {
        return false
      }

      if (row === selectedRow.value && similarUserActive.value && !similarUser.value) {
        return true
      }
      return false
    }

    const isSelected = (row, col) => {
      if (col === selectedCol.value && row < selectedRow.value && active.value) {
        return true
      }
      return selectedRow.value === row && col < selectedCol.value && active.value
    }

    const action = (row, col, answer) => {
      const elem = proxyMatrixArr.value[row].matrix[col]
      elem.answer = answer
      elem.activate = false
      if (elem.val === Number(elem.answer)) {
        if (elem.val) {
          pushPopup(arrPopup2, messages.value)
          elem.icon = 10
        } else {
          pushPopup(arrPopup3, messages.value)
          elem.icon = 'cross'
        }
      } else {
        pushPopup(arrPopup4, messages.value)
      }
    }

    const activateButton = (row, col) => {
      if (!similarUser.value || !active.value) return
      const elem = proxyMatrixArr.value[row].matrix[col]
      if (elem.answer === null || elem.val !== Number(elem.answer)) {
        elem.activate = true
      } else {
        elem.activate = false
      }
    }
    onMounted(() => {
      pushPopup(props.arrPopup1, messages.value)
    })

    watch(() => proxyMatrixArr.value, () => {
      const find = proxyMatrixArr.value.find(item => item?.me).matrix.filter(item => item.question)
      const equal = find.every(elem => elem.answer !== null && (Number(elem.answer) === elem.val))
      if (equal) {
       // find.forEach(elem => elem.answer !== null && (Number(elem.answer) === elem.val))
        pushPopup(nextLesson, messages.value)
      }
    }, { deep: true })

    const nextStage = () => {
      messages.value = []
      // if (stage.value === 0) {
      //     pushPopup(props.arrPopup1, messages.value)
      // }
      if (stage.value === 0) {
        similarUserActive.value = true
      }
      if (stage.value === 1) {
        active.value = true
      }
      if (stage.value === 2) {
        emit('nextStep')
      }
      stage.value += 1
    }

    const chooseSimilarUser = (author, indexRow) => {
      if (proxyMatrixArr.value.length - 1 === indexRow) return
      if (similarUser.value || !similarUserActive.value) return
      if (author.matched && author.active) return
      if (author.matched && !author.active) {
          author.active = true
          const find = proxyMatrixArr.value.filter(item => item?.matched).every(item => item.active)
          if (find) {
            similarUser.value = true
            pushPopup(props.arrPopupChooseUser, messages.value)
            task.value = props.task2
          }
      } else {
        pushHint(arrPopupChooseUserWrong, messages.value)
      }
    }

    return {
      selectedRow,
      selectedCol,
      clickIndex,
      similarUser,
      proxyMatrixArr,
      arr,
      ICON,
      messages,
      task,

      nextStage,
      activateButton,
      chooseSimilarUser,
      action,
      isSelected,
      handleMouseOver,
      handleMouseOut,
      handleMouseOverRow,
      handleMouseOutRow,
      isSelectedRow,
    }
  },
}
